import React from 'react';
import wingitDesign from '../designSystem';

export default function WingitInput({
  error = false,
  style = {},
  ...props
}) {
  return (
    <input
      {...props}
      style={{
        ...wingitDesign.publicPages.input,
        borderColor: error
          ? wingitDesign.colors.danger
          : wingitDesign.publicPages.input.border,
        ...style,
      }}
    />
  );
}